import { FlisRecordResult } from '@/api/api';
import { PartFinderReport } from '@/api/generatedApi';

export type PartNumberSuggestion =
  | { kind: 'report'; report: PartFinderReport }
  | { kind: 'flis'; record: FlisRecordResult };

const digitsOnly = (value: string): string => value.replaceAll(/\D/g, '');

export const suggestionLabel = (option: string | PartNumberSuggestion): string => {
  if (typeof option === 'string') {
    return option;
  }
  return option.kind === 'report' ? option.report.partNumber : option.record.nsn;
};

export const suggestionKey = (option: PartNumberSuggestion): string =>
  option.kind === 'report' ? `report:${option.report.id}` : `flis:${option.record.niin}`;

export const mergeSuggestions = (
  reports: PartFinderReport[],
  flisRecords: FlisRecordResult[]
): PartNumberSuggestion[] => {
  const alreadySearched = new Set(reports.map(report => digitsOnly(report.partNumber)));

  const reportOptions: PartNumberSuggestion[] = reports.map(report => ({ kind: 'report', report }));
  const flisOptions: PartNumberSuggestion[] = flisRecords
    .filter(record => !alreadySearched.has(record.niin) && !alreadySearched.has(digitsOnly(record.nsn)))
    .map(record => ({ kind: 'flis', record }));

  return [...reportOptions, ...flisOptions];
};
